import React, { useState } from "react";
import { Link, NavLink } from 'react-router-dom';
import { Nav, Container, Col, Row } from 'react-bootstrap';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


const EditCompanyProfile = () => {

  const [description, setDescription] = useState("");

  return (
    <div>


    <div className="js-pg-hg mt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">

                     <div class="heading d-flex justify-content-between mb-4 align-content-end">
                          <div>
                       <h6 class="card-title text-primary mb-2">Veritis Group Inc</h6>
                       <h4>Edit Your Comapany Page</h4>
                       </div>
                       <div className='pt-2'>
                    <NavLink to="/CompanyProfile" className='btn btn-outline-primary text-primary'><i class='bx me-1 text-primary bx-left-arrow-alt' ></i> Back to Your Profile</NavLink>
                </div>
                       </div>

           <div className="sub-header-profile shadow-sm py-3 px-3 bg-light rounded-4 mb-4">
    <Container>
      <Row className="align-items-start">
        <Col md={12}>
          <Nav className="justify-content-start">
            <Nav.Item>
              <Nav.Link as={Link} to="/category1" className="text-dark active">About</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Services</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category3" className="text-dark">Products</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Portfolio</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Awards</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Reviews</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Announcement</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/category2" className="text-dark">Contact</Nav.Link>
            </Nav.Item>



          </Nav>
        </Col>
      </Row>
    </Container>
  </div>
           <form className=''>
           <div class="card rounded-4 p-4 mb-5">

           <div class="card-header border-bottom">
           <h5>Company Info</h5>
           <p className='pt-0 text-secondary'>Fill in some generic information about your company.</p>
           </div>



        <div class="card-body pt-4">
            <div class="row g-8">
              <div class="col-md-12 mb-4 ">
                <label for="firstName" class="form-label">Company Name</label>
                <input class="form-control" type="text" id="companyname" name="companyname" value="Veritis Group Inc" />
              </div>

              <div class="col-md-12 mb-4 ">
                <label for="firstName" class="form-label">Company Tagline (Optional)</label>
                <input class="form-control" type="text" id="companyname" name="companyname" value="US-based IT Services Provider: Cloud, DevOps, Digital Transformation, Identity Management, and Artificial Intelligence!" autofocus="" />
              </div>
              <div class="col-md-6 ">
                <label for="lastName" class="form-label">Your Team</label>
                <input class="form-control" type="number" name="number" id="number" value="50" />
              </div>
              <div class="col-md-6 mb-4">
                <label for="currency" class="form-label">Founded in  (Optional)</label>
                <div class="position-relative"><select id="founded" class="select2 form-select select2-hidden-accessible" data-select2-id="founded" tabindex="-1" aria-hidden="true">
                  <option value="" data-select2-id="8">2024</option>
                  <option value="usd">2023</option>
                  <option value="euro">2022</option>
                  <option value="pound">2021</option>
                  <option value="bitcoin">2021</option>
                </select></div>
              </div>
              <div class="col-md-6 mb-4">
                <label for="language" class="form-label">Language Spoken</label>
                <div class="position-relative"><select id="language" class="select2 form-select select2-hidden-accessible" data-select2-id="language" tabindex="-1" aria-hidden="true">
                  <option value="en">English</option>
                  <option value="fr">French</option>
                  <option value="de">German</option>
                  <option value="pt">Portuguese</option>
                </select></div>
              </div>
              <div class="col-md-6 ">
                <label for="lastName" class="form-label">Annual turnover  (optional)</label>
                <input class="form-control" type="number" name="number" id="number" value="250" />
              </div>


              <div class="col-md-12 mb-4 ">
                <label for="firstName" class="form-label">Company Description (Optional)</label>
                <ReactQuill theme="snow" style={{ height: "200px" }}  value={description} onChange={setDescription} />
              </div>



        <div class="card-header mt-4 pt-5 border-bottom">
           <h5>Upload</h5>
           <p className='pt-0 text-secondary'>Upload your company logo and banner.</p>
           </div>

           <div class="row pt-4">
           <div class="col-md-3">
            <div className="mb-5 p-5">
            <label class="form-label">Logo (optional)</label>

           <img src="" class="img-fluid img-thumbnail" alt="..." />
           </div>
           </div>
           <div class="col-md-9">
           <div className="bg-light mb-5 p-5">
           Banner (optional)
          </div>
           </div>
</div>


           <div class="mt-6">
            <button type="reset" class="btn btn-outline-primary text-primary me-3">Cancel</button>
              <button type="submit" class="btn btn-primary">Save changes</button>
            </div>

      </div>

      </div>


        </div>

        </form>


          </div>
        </div>
      </div>

      <div>

    </div>
    </div>

    </div>
  );
};

export default EditCompanyProfile;